// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Yna-z","updatedSizingPrediction":"Zna-z","recommendedSize":"_na-z","predictedSize":"aoa-z","recommendedSizeCopy":"boa-z"};